import { Box, Stack } from '@mui/system'
import { FC } from 'react'
import WarningIcon from '@mui/icons-material/Warning'
import {
  AbandonedOutdoorActivityResultType,
  BouncedOutdoorActivityResultType,
  DroppedOutdoorActivityResultType,
  NoVideoAvailableOutdoorActivityResultType,
  OutdoorEngagement,
  ProcessedActivity
} from '../../../../../../api/models'
import { ActivityTimingResult } from '../useActivityTiming'
import { ActivityFieldBox } from '../ActivityFieldBox'
import { StartEndTimeBox } from '../StartEndTimeBox'
import { camelCaseToSplitWords } from '../../../activityUtils'
import { EqualColumnsGrid } from '../../EqualColumnsGrid'

const INCOMPLETE_ENGAGEMENT_RESULT_TYPES: ReadonlySet<string> = new Set([
  AbandonedOutdoorActivityResultType.Abandoned,
  BouncedOutdoorActivityResultType.Bounced,
  DroppedOutdoorActivityResultType.Dropped,
  NoVideoAvailableOutdoorActivityResultType.NoVideoAvailable
])

export interface SharedActivityProps {
  activity: ProcessedActivity
  engagement: OutdoorEngagement
  timing: ActivityTimingResult
}

export const SharedActivity: FC<SharedActivityProps> = ({ activity, timing }) => {
  const resultType = activity.completed?.result?.type
  const isIncompleteEngagementResult = !!resultType && INCOMPLETE_ENGAGEMENT_RESULT_TYPES.has(resultType)

  return (
    <EqualColumnsGrid>
      <StartEndTimeBox
        data-testid="activity-card-start-end"
        startMs={timing.startOffsetMs}
        startSeconds={timing.startOffsetSeconds}
        endMs={timing.endOffsetMs}
        endSeconds={timing.endOffsetSeconds}
        isCompleted={!!activity.completed}
      />
      <ActivityFieldBox label="Result" labelTestId="activity-card-result">
        <Stack direction="row" sx={{ alignItems: 'center', gap: 'var(--spacing-3xs)' }}>
          <Box sx={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }} data-testid="activity-card-result-value">
            {camelCaseToSplitWords(resultType)}
          </Box>
          {isIncompleteEngagementResult && (
            <WarningIcon data-testid="activity-card-incomplete-icon" fontSize="small" sx={{ color: 'var(--text-warning)' }} />
          )}
        </Stack>
      </ActivityFieldBox>
    </EqualColumnsGrid>
  )
}
